import { CodeEspece } from './enums/code-espece.enum';

export class Stock {
    static jsonMap = {
        idGroupeVarietal: { key: 'idGroupeVarietal', optional: true },
        stockTotalMoisCourant: { key: 'stockTotalMoisCourant', optional: true },
        stockBioMoisCourant: { key: 'stockBioMoisCourant', optional: true },
        stockTotalCampPrec: { key: 'stockTotalCampPrec', optional: true },
        stockBioCampPrec: { key: 'stockBioCampPrec', optional: true },
        stockTotalMoisPrec: { key: 'stockTotalMoisPrec', optional: true },
        stockBioMoisPrec: { key: 'stockBioMoisPrec', optional: true },
        stockTotalRecolte: { key: 'stockTotalRecolte', optional: true },
        stockBioRecolte: { key: 'stockBioRecolte', optional: true },
        stockTotalMoisSuiv: { key: 'stockTotalMoisSuiv', optional: true },
        stockBioMoisSuiv: { key: 'stockBioMoisSuiv', optional: true },
        idEspece: { key: 'idEspece', optional: true },
        codeEspece: { key: 'codeEspece', optional: true, default: '' },
        codeGroupeVarietal: { key: 'codeGroupeVarietal', optional: true, default: '' },
        groupeVarietal: { key: 'groupeVarietal', optional: true, default: '' }
    };

    idGroupeVarietal: number = null;
    stockTotalMoisCourant: number = null;
    stockBioMoisCourant: number = null;
    stockTotalCampPrec: number = null;
    stockBioCampPrec: number = null;
    stockTotalMoisPrec: number = null;
    stockBioMoisPrec: number = null;
    stockTotalRecolte: number = null;
    stockBioRecolte: number = null;
    stockTotalMoisSuiv: number = null;
    stockBioMoisSuiv: number = null;
    idEspece: number = null;
    codeEspece: string = null;
    codeGroupeVarietal: string;
    groupeVarietal: string = null;

    isAutre(): boolean {
        return ['autVarpomme', 'autVarpoir', 'autVarpoire'].indexOf(this.codeGroupeVarietal) > -1;
    }

    isTotal = false;

    isDernierPommePoire = false;

    sorting(): string {
        const x = ''.concat(
            this.codeEspece === CodeEspece.POMME ? '0' : '1',
            this.isTotal ? '1' : '0',
            this.isAutre() ? '1' : '0',
            this.groupeVarietal.toUpperCase()
        );
        return x;
    }
}
